import { db } from '../firebase/config';
import {
  doc, setDoc, getDoc, deleteDoc, onSnapshot, serverTimestamp,
} from 'firebase/firestore';

const reportRef    = (pid)       => doc(db, 'projects', pid, 'externtid', 'latest');
const progressRef  = (pid, uid)  => doc(db, 'projects', pid, 'externtid_progress', uid);
const sysConfigRef = (pid)       => doc(db, 'projects', pid, 'externtid', 'sysconfig');
const credsRef     = (pid, uid)  => doc(db, 'projects', pid, 'externtid_creds', uid);

// Upload / overwrite the time-report for a project
export async function uploadExternTidReport(projectId, userId, uploaderName, fileName, entries) {
  await setDoc(reportRef(projectId), {
    uploadedAt:   serverTimestamp(),
    uploadedBy:   userId,
    uploaderName,
    fileName,
    entries,
  });
}

// Delete the uploaded time-report for a project
export async function deleteExternTidReport(projectId) {
  await deleteDoc(reportRef(projectId));
}

// Real-time listener for the project's time-report
// Returns an unsubscribe function.
export function subscribeExternTid(projectId, callback) {
  return onSnapshot(reportRef(projectId), (snap) => {
    callback(snap.exists() ? { id: snap.id, ...snap.data() } : null);
  });
}

// Persist which days a user has marked as "copied"
export async function saveExternTidProgress(projectId, userId, copiedDays) {
  await setDoc(
    progressRef(projectId, userId),
    { copiedDays, updatedAt: serverTimestamp() },
    { merge: true },
  );
}

// Fetch a user's progress (returns {} if none yet)
export async function getExternTidProgress(projectId, userId) {
  const snap = await getDoc(progressRef(projectId, userId));
  return snap.exists() ? (snap.data().copiedDays || {}) : {};
}

// Save system config (login details, URL, instructions)
export async function saveExternTidSysConfig(projectId, config) {
  await setDoc(sysConfigRef(projectId), { ...config, updatedAt: serverTimestamp() });
}

// Real-time listener for system config
export function subscribeExternTidSysConfig(projectId, callback) {
  return onSnapshot(sysConfigRef(projectId), (snap) => {
    callback(snap.exists() ? snap.data() : null);
  });
}

// Personal credentials — only the owner should read/write these
export async function saveExternTidCreds(projectId, userId, creds) {
  await setDoc(credsRef(projectId, userId), { ...creds, updatedAt: serverTimestamp() });
}

export async function getExternTidCreds(projectId, userId) {
  const snap = await getDoc(credsRef(projectId, userId));
  return snap.exists() ? snap.data() : { anvandarnamn: '', losenord: '' };
}
